/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { useCallback, useEffect, useMemo, useRef, useState } from "react";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";

// Images
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";

import DataTable from "examples/Tables/DataTable";
import {
  Button,
  Card,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Icon,
  Menu,
  MenuItem,
  Switch,
} from "@mui/material";
import applicator from "ajv/dist/vocabularies/applicator";
import colors from "assets/theme/base/colors";
import { useNavigate } from "react-router-dom";
import NotificationItem from "examples/Items/NotificationItem";
import moment from "moment";
import debounce from "lodash.debounce";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { exportToExcel } from "utilities";
import { getAllFair } from "api";
import { NumberFormatter } from "utilities";
import { fairStatus } from "utilities";
import { statusColors } from "utilities";
import AddFair from "layouts/fair/add-fair";
import { notify } from "utilities";
import { deleteFair } from "api";
import { sendReminder } from "api";
import { toast } from "react-toastify";

// import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import dayjs from "dayjs";

export default function data({}) {
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(50);

  const [menuAnchor, setMenuAnchor] = useState(null);
  const [currentRowId, setCurrentRowId] = useState(null);

  const [loading, setLoading] = useState(false);

  const [search, setSearch] = useState();
  const [loadingId, setLoadingId] = useState(null);

  const [openConfirm, setOpenConfirm] = useState(false);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const arrStatus = [
    { key: "all", name: "All" },
    { key: "planned", name: "Planned" },
    { key: "ongoing", name: "Ongoing" },
    { key: "completed", name: "Completed" },
    { key: "cancelled", name: "Cancelled" },
  ];
  const [status, setStatus] = useState(arrStatus[0]);

  const [showAdd, setShowAdd] = useState(false);
  const [fairData, setFairData] = useState();

  const lastSearch = useRef("");
  const isFetching = useRef(false);
  const lastApiParams = useRef("");
  const resizeTimeout = useRef(null);
  const didMount = useRef(false);
  const isFirstLoad = useRef(true);

  useEffect(() => {
    const handleResize = () => {
      clearTimeout(resizeTimeout.current);
      resizeTimeout.current = setTimeout(() => {
        // do nothing → just absorb resize re-renders
      }, 300);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (didMount.current) return;

    didMount.current = true;

    getAllFairApi();
  }, []);

  useEffect(() => {
    if (isFirstLoad.current) {
      isFirstLoad.current = false;
      return;
    }
    getAllFairApi();
  }, [search]);

  const debouncedFetch = useMemo(
    () =>
      debounce((searchVal) => {
        setSearch(searchVal);
      }, 500),
    []
  );

  useEffect(() => {
    return () => {
      debouncedFetch.cancel();
    };
  }, [debouncedFetch]);

  const getAllFairApi = (isReset = false) => {
    var params = {
      page: page,
      limit: limit,
      name: search,
    };

    if (isReset) {
      params.status = "all";
      // params.industry = "all";
      // params.location = "all";
      // params.sponsor = "all";
    } else {
      params.status = status?.key || "all";
      // params.industry = industry?._id || "all";
      // params.location = location?.name || "all";
      // params.sponsor = sponsor?._id || "all";
    }

    const key = JSON.stringify(params);
    // 🚀 BLOCK if same API already called
    if (lastApiParams.current === key) return;

    lastApiParams.current = key;

    if (isFetching.current) return; // 🚀 BLOCK duplicate calls
    isFetching.current = true;

    setLoading(true);

    getAllFair({
      params: params,
    })
      .then((responseJson) => {
        if (responseJson) {
          if (responseJson?.status === 400) {
          } else {
            setList(responseJson?.fair || 0);
            setTotal(responseJson?.total || 0);
          }
        }
      })
      .catch((e) => {})
      .finally(() => {
        setLoading(false);
        isFetching.current = false;
      });
  };

  const onSearchData = (val) => {
    if (lastSearch.current === val) return; // 🚀 STOP duplicate
    lastSearch.current = val;
    setPage(1);
    debouncedFetch(val);
  };

  const handleAction = (event, rowId) => {
    setMenuAnchor(event.currentTarget);
    setCurrentRowId(rowId);
  };

  const closeMenu = () => {
    setMenuAnchor(null);
  };

  const onPressAdd = () => {
    setCurrentRowId(null);
    setFairData();
    setShowAdd(true);
  };

  const onSubmitAddFair = () => {
    setShowAdd(false);
    getAllFairApi();
  };

  const columns = useMemo(() => {
    return [
      { Header: "name", accessor: "name", align: "left" },
      { Header: "start date - end date", accessor: "date", align: "center" },
      { Header: "venue", accessor: "venue", align: "center" },
      {
        Header: "registrations",
        accessor: "registrations",
        align: "center",
      },
      {
        Header: "checked-in",
        accessor: "checkedIn",
        align: "center",
      },
      {
        Header: "status",
        accessor: "status",
        align: "center",
      },
      {
        Header: "actions",
        accessor: "actions",
        align: "center",
      },
    ];
  }, []);

  const confirmDialog = () => {
    return (
      <Dialog open={openConfirm} onClose={() => setOpenConfirm(false)}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          Are you sure you want to delete this fair? This action cannot be undone.
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirm(false)} color="error" variant="contained">
            Cancel
          </Button>
          <MDButton onClick={handleDelete} color="error">
            Delete
          </MDButton>
        </DialogActions>
      </Dialog>
    );
  };

  const handleDelete = () => {
    setOpenConfirm(false);

    deleteFairApi();
  };

  const deleteFairApi = () => {
    var params = {};

    deleteFair({
      params: params,
      id: currentRowId,
    })
      .then((responseJson) => {
        if (responseJson) {
          if (responseJson?.status === 400) {
          } else {
            notify();
            getAllFairApi();
          }
        }
      })
      .catch((e) => {});
  };

  const onUploadClick = () => {
    closeMenu();
    const item = list.find((item) => item._id === currentRowId);
    navigate("/upload", { state: { fair: item } });
  };

  const onDashboardClick = () => {
    closeMenu();
    const item = list.find((item) => item._id === currentRowId);
    navigate("/dashboard", { state: { fair: item } });
  };

  const onLocationClick = () => {
    closeMenu();
    const item = list.find((item) => item._id === currentRowId);
    navigate("/location", { state: { fair: item } });
  };

  const onUserClick = () => {
    closeMenu();
    const item = list.find((item) => item._id === currentRowId);
    navigate("/user", { state: { fair: item } });
  };

  const onEditClick = () => {
    closeMenu();
    setFairData(list.find((item) => item._id === currentRowId));
    setShowAdd(true);
  };
  const onDeleteClick = () => {
    // Implement delete functionality here
    closeMenu();
    setOpenConfirm(true);
  };

  const onClickSendEmailWhatsApp = () => {
    closeMenu();
    const item = list.find((item) => item._id === currentRowId);
    sendReminderApi(item);
  };

  const sendReminderApi = (fair) => {
    var params = {
      fair: fair?._id,
    };

    sendReminder({
      params: params,
    })
      .then((responseJson) => {
        if (responseJson) {
          if (responseJson?.status === 400) {
            toast.warn(responseJson?.msg);
          } else {
            notify();
          }
        }
      })
      .catch((e) => {})
      .finally(() => {
        setLoading(false);
      });
  };

  const renderActionMenu = (rowId) => (
    <Menu
      id={`simple-menu-${rowId}`}
      anchorEl={menuAnchor}
      anchorReference={null}
      anchorOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      open={Boolean(menuAnchor) && currentRowId === rowId}
      onClose={closeMenu}
      sx={{ mt: 2 }}
    >
      <NotificationItem
        icon={<Icon>dashboard</Icon>}
        title="Dashboard"
        onClick={onDashboardClick}
      />
      <NotificationItem icon={<Icon>upload</Icon>} title="Upload List" onClick={onUploadClick} />
      <NotificationItem
        icon={<Icon>send</Icon>}
        title="Send Email & Whatsapp"
        onClick={onClickSendEmailWhatsApp}
      />

      <NotificationItem
        icon={<Icon>location_on</Icon>}
        title="Location"
        onClick={onLocationClick}
      />
      <NotificationItem icon={<Icon>people_alt</Icon>} title="User" onClick={onUserClick} />
      <NotificationItem icon={<Icon>mode_edit</Icon>} title="Edit" onClick={onEditClick} />
      <NotificationItem
        icon={<Icon>delete</Icon>}
        title={
          <>
            <span style={{ color: "red" }}>Delete</span>
          </>
        }
        onClick={onDeleteClick}
      />
    </Menu>
  );

  const handleDirection = (item) => {
    window.open(item?.directionLink, "_blank", "noopener,noreferrer");
  };

  const handleApplicant = (item) => {
    navigate("/registration", { state: { fair: item } });
  };

  const handleCheckIn = (item) => {
    navigate("/checkin", { state: { fair: item } });
  };

  const rows = useMemo(() => {
    var rowsData = [];

    list.map((item) =>
      rowsData.push({
        name: (
          <MDBox>
            <MDTypography
              display="block"
              variant="button"
              fontWeight="medium"
              noWrap
              sx={{
                maxWidth: "250px",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {item?.name}
            </MDTypography>

            <MDTypography variant="caption" fontWeight="medium" color="secondary">
              {item?.fairCode}
            </MDTypography>
          </MDBox>
        ),
        date: (
          <MDBox sx={{ px: 1 }}>
            <MDTypography display="block" variant="caption" noWrap>{`${moment(
              item?.startDate
            ).format("DD MMM YYYY hh:mm A")}`}</MDTypography>
            <MDTypography variant="caption" noWrap>{`${moment(item?.endDate).format(
              "DD MMM YYYY hh:mm A"
            )}`}</MDTypography>
          </MDBox>
        ),
        venue: (
          <MDBox
            sx={{ px: 1, textAlign: "left", cursor: "pointer" }}
            onClick={() => handleDirection(item)}
          >
            <MDTypography variant="caption" fontWeight="medium" noWrap>
              {item?.venue}
            </MDTypography>
            <MDTypography
              variant="caption"
              display="block"
              noWrap
              sx={{
                minWidth: "250px",
                maxWidth: "250px",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {item?.address}
            </MDTypography>
          </MDBox>
        ),
        registrations: (
          <MDBox
            display="flex"
            gap={0.5}
            color="secondary"
            sx={{ px: 1, cursor: "pointer" }}
            onClick={() => handleApplicant(item)}
          >
            <MDBadge
              badgeContent={NumberFormatter(parseInt(item?.registrationCount || 0))}
              color={"light"}
              variant="gradient"
              size="sm"
              circular
            />
            <Icon fontSize="small">people_alt</Icon>
          </MDBox>
        ),
        checkedIn: (
          <MDBox
            display="flex"
            gap={0.5}
            color="secondary"
            sx={{ px: 1, cursor: "pointer" }}
            onClick={() => handleCheckIn(item)}
          >
            <MDBadge
              badgeContent={NumberFormatter(parseInt(item?.checkInCount || 0))}
              color={"light"}
              variant="gradient"
              size="sm"
              circular
            />
            <Icon fontSize="small">people_alt</Icon>
          </MDBox>
        ),
        status: (
          <MDBox sx={{ px: 1 }}>
            <MDBadge
              badgeContent={fairStatus[item?.status] || "Planned"}
              color={statusColors[item?.status] || "secondary"}
              variant="gradient"
              size="sm"
              // sx={{ cursor: "pointer" }}
              circular
            ></MDBadge>
          </MDBox>
        ),
        actions: (
          <MDBox sx={{ px: 1 }} onClick={(e) => handleAction(e, item?._id)}>
            <MDTypography
              component="a"
              variant="caption"
              color="secondary"
              fontWeight="medium"
              sx={{ cursor: "pointer" }}
            >
              <Icon fontSize="small">more_vert</Icon>
            </MDTypography>
          </MDBox>
        ),
      })
    );

    return rowsData;
  }, [list]);

  const handleApplyFilter = () => {
    if (page === 1) {
      getAllFairApi();
    } else {
      setPage(1);
    }
  };
  const handleResetFilter = useCallback(() => {
    // setStartDate("");
    // setEndDate("");
    setStatus(arrStatus[0]);

    getAllFairApi(true);
  }, [arrStatus]);

  const ViewFilter = () => {
    return (
      <Card sx={{ mb: 3 }}>
        <MDBox
          p={3}
          display="flex"
          flexDirection={{ xs: "column", sm: "row" }}
          flexWrap="wrap"
          gap={2}
        >
          {/* <MDBox sx={{ width: { xs: "100%", sm: "200px" } }}>
            <MDInput
              type="date"
              label="Start Date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              fullWidth
              InputProps={{ sx: { height: "44px" } }}
              InputLabelProps={{ shrink: true }}
            ></MDInput>
          </MDBox>
          <MDBox sx={{ width: { xs: "100%", sm: "200px" } }}>
            <MDInput
              type="date"
              label="End Date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              fullWidth
              InputProps={{ sx: { height: "44px" } }}
              InputLabelProps={{ shrink: true }}
            ></MDInput>
          </MDBox> */}
          <MDBox sx={{ width: { xs: "100%", sm: "200px" } }}>
            <MDInput
              select
              label="Status"
              value={JSON.stringify(status)}
              onChange={(e) => setStatus(JSON.parse(e.target.value))}
              fullWidth
              InputProps={{ sx: { height: "44px" } }}
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    style: {
                      maxHeight: 200,
                      maxWidth: 200,
                    },
                  },
                },
              }}
            >
              {arrStatus.map((item, index) => (
                <MenuItem key={index} value={JSON.stringify(item)}>
                  {item?.name}
                </MenuItem>
              ))}
            </MDInput>
          </MDBox>
        </MDBox>
        <MDBox
          mb={3}
          ml={3}
          mr={3}
          display="flex"
          flexDirection={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          gap={2}
        >
          <MDBox display="flex" flexDirection={{ xs: "column", sm: "row" }} gap={2}>
            <MDButton onClick={handleApplyFilter} variant="gradient" color="info">
              apply
            </MDButton>
            <Button onClick={handleResetFilter} color="error" variant="contained">
              reset
            </Button>
          </MDBox>
        </MDBox>
      </Card>
    );
  };

  return (
    <MDBox>
      <ViewFilter />
      <Card>
        <MDBox p={3} sx={{ width: "100%", overflowX: "auto" }}>
          <DataTable
            table={{ columns, rows }}
            isSorted={false}
            entriesPerPage={false}
            showTotalEntries={true}
            canSearch={true}
            onSearch={onSearchData}
            page={page}
            limit={limit}
            total={total}
            onPageChange={(newPage) => setPage(newPage)}
            canAdd={{
              onClick: onPressAdd,
              label: "Add",
            }}
          />
          {list.map((item) => renderActionMenu(item?._id))}

          {/* {confirmDialogAdd()} */}

          {confirmDialog()}

          {showAdd && (
            <AddFair
              visible={showAdd}
              fairData={fairData}
              onClose={() => {
                setShowAdd(false);
              }}
              onSubmit={onSubmitAddFair}
            ></AddFair>
          )}

          {loading && (
            <MDBox display="flex" justifyContent="center" mt={2}>
              <CircularProgress size={24} color="info" />
            </MDBox>
          )}
        </MDBox>
      </Card>
    </MDBox>
  );
}
